module.exports = __webpack_public_path__ + "img/money-smile.ba5128db.svg";